import { render, staticRenderFns } from "./SecSO.vue?vue&type=template&id=4d9572af&scoped=true"
import script from "./SecSO.vue?vue&type=script&lang=js"
export * from "./SecSO.vue?vue&type=script&lang=js"
import style0 from "./SecSO.vue?vue&type=style&index=0&id=4d9572af&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9572af",
  null
  
)

export default component.exports